import React from 'react';
import { useDispatch } from 'react-redux';
import { openLoginModal } from 'dispatcher/modalDispatcher';
import { LOGIN_MODAL, TYPES } from 'constants/login';
import LoginButton from 'components/auth/LoginButton';
import mixpanel, { trackedEvents } from 'utils/mixpanel';

// Refactor later for signup block card
const RewardSignUpCard = () => {
  const dispatch = useDispatch();

  return (
    <div className="rounded w-full h-fit">
      <div className="flex flex-col items-center gap-2 w-full">
        <div className="flex flex-col items-center gap-1">
          <p className="text-sm font-bold text-center">
            Sign up for a free account to redeem this reward!
          </p>
        </div>
        <div className="flex gap-4 justify-center w-full">
          <LoginButton
            variant="google"
            trackingParam="login_google"
            isIconOnly
          />
          <LoginButton
            trackingParam="login_facebook"
            variant="facebook"
            isIconOnly
          />
          <LoginButton trackingParam="login_apple" variant="apple" isIconOnly />
          <LoginButton trackingParam="login_email" variant="email" isIconOnly />
        </div>
        <p className="text-neutral-500">
          Have an account?{' '}
          <span
            className="text-blue-500 hover:underline cursor-pointer"
            onClick={() => {
              dispatch(openLoginModal(LOGIN_MODAL[TYPES.REWARD]));
              mixpanel.track(trackedEvents.RewardsCollection, {
                param: 'log_in',
              });
            }}
          >
            Log in
          </span>
        </p>
      </div>
    </div>
  );
};

export default RewardSignUpCard;
